import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type React from "react";
import { useI18n } from "@/lib/i18n/use-i18n";
import { cn } from "@/lib/utils";

type ArrowTarget =
	| "/{-$locale}/services/applications-metier"
	| "/{-$locale}/services/migration-react-native-expo"
	| "/{-$locale}/realisations"
	| "/{-$locale}/realisations/questovery"
	| "/{-$locale}/realisations/vaerdict"
	| "/{-$locale}/produits"
	| "/{-$locale}/a-propos";

/** Underlined text link with a sliding arrow, used at the end of a block. */
export function ArrowLink({
	to,
	children,
	className,
}: {
	to: ArrowTarget;
	children: React.ReactNode;
	className?: string;
}) {
	const { localeParams } = useI18n();

	return (
		<Link
			to={to}
			params={localeParams}
			className={cn(
				"group/link inline-flex items-center gap-2 border-b border-foreground/20 pb-1 font-medium transition-colors hover:border-signal",
				className,
			)}
		>
			{children}
			<ArrowRight className="size-4 transition-transform duration-300 ease-(--ease-soft) group-hover/link:translate-x-1" />
		</Link>
	);
}
